import React from 'react'

const SmallHeading = ({children, className = ''}) => {
  return (
    <h5 className={`${className} text-lg leading-6 font-medium text-gray-900`}>
      {children}
    </h5>

  )
}

export default SmallHeading
